// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: 'b5f91c60398fee4056979c3a219be04458b7bc13',
  short: 'b5f91c6',
  builtAt: '2026-10-26T11:51:01.249Z',
} as const;
